module.exports = __webpack_public_path__ + "img/19.afd8d493.jpg";